module.exports = __webpack_public_path__ + "img/Devices-background-gray.d419aa0d.svg";